"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@mapmaker/core");
const useProjectState_1 = require("../useProjectState");
// Single feature hook
function useFeature(featureId, type) {
    const file = (0, useProjectState_1.useProjectFile)();
    const feature = (0, core_1.getFeature)(file.design, featureId, type);
    const featureInput = (0, core_1.getInput)(file, featureId, type);
    return {
        feature: feature,
        featureInput: featureInput,
    };
}
exports.default = useFeature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRmVhdHVyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3Byb2plY3QvZmVhdHVyZXMvdXNlRmVhdHVyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlDQUE2RTtBQUM3RSx3REFBb0Q7QUFFcEQsc0JBQXNCO0FBQ3RCLFNBQXdCLFVBQVUsQ0FHaEMsU0FBaUIsRUFBRSxJQUFxQjtJQUN4QyxNQUFNLElBQUksR0FBRyxJQUFBLGdDQUFjLEdBQUUsQ0FBQztJQUM5QixNQUFNLE9BQU8sR0FBRyxJQUFBLGlCQUFVLEVBQUksSUFBSSxDQUFDLE1BQU0sRUFBRSxTQUFTLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDNUQsTUFBTSxZQUFZLEdBQUcsSUFBQSxlQUFRLEVBQUksSUFBSSxFQUFFLFNBQVMsRUFBRSxJQUFpQixDQUFDLENBQUM7SUFDckUsT0FBTztRQUNMLE9BQU8sRUFBRSxPQUFPO1FBQ2hCLFlBQVksRUFBRSxZQUFZO0tBQzNCLENBQUM7QUFDSixDQUFDO0FBWEQsNkJBV0MifQ==